import Link from 'next/link'
import { ReactNode } from 'react'

import {
  Box,
  BoxProps,
  Breadcrumbs as MuiBreadcrumbs,
  Skeleton
} from '@mui/material'

import ArrowRightIcon from 'app/assets/icons/arrow-right.svg'
import Text from 'app/components/base/Text'

export interface BreadcrumbsProps extends Omit<BoxProps, 'color'> {
  items: { href: string; child?: ReactNode }[]
  isAllLinks?: boolean
}

const Breadcrumbs: RFC<BreadcrumbsProps> = ({ items, isAllLinks, ...rest }) => {
  return (
    <Box {...rest}>
      <MuiBreadcrumbs
        aria-label="breadcrumb"
        separator={<ArrowRightIcon />}
        sx={{
          lineHeight: '20px',

          '.MuiBreadcrumbs-li > a': {
            fontFamily: 'Poppins',
            fontWeight: 300,
            fontSize: 14,
            lineHeight: '20px',
            textDecoration: 'none',
            color: 'text.third',

            '&:hover': { textDecoration: 'underline' }
          }
        }}
      >
        {items.map((item, index) => {
          const isLastItem = index === items.length - 1
          const isLink = !isLastItem || isAllLinks

          if (isLink) {
            return (
              <Link key={item.href} href={item.href}>
                {item.child ? item.child : <Skeleton width={40} />}
              </Link>
            )
          }

          return (
            <Text
              key={item.href}
              variant="subtitle1"
              color="text.secondary"
              sx={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 1
              }}
            >
              {item.child ? item.child : <Skeleton width={40} />}
            </Text>
          )
        })}
      </MuiBreadcrumbs>
    </Box>
  )
}

export default Breadcrumbs
